import React, { useState, useEffect, useMemo } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { MdOutlineFileUpload } from "react-icons/md";

import "./serviceImage.css";
import Popup from "reactjs-popup";
import { Container, Spinner } from "react-bootstrap";
import { baseUrl } from "../../../../../../../../../../../../../network/constants/constants";
import config, { getConfig } from "../../../../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../../../../network/api";
import "./serviceImage.css";

const ServiceImage = ({ serviceList, serviceId }) => {
  const [loading, setLoading] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  
  const config = useMemo(() => {
    return getConfig()
  },[])
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("service_images", selectedFile);
    formData.append("service", serviceId);

    setLoading(true);
    axios
      .post(baseUrl + `app/gallery/create/`, formData, {
        headers: {
          "Authorization": config.headers.Authorization,
        },
      })
      .then((response) => {
        fetchGallery();
      })
      .catch((error) => {
        console.error("Upload Error:", error);
      })
      .finally(() => {
        setLoading(false);
        setSelectedFile(null);
        setPreviewUrl(null);
      });
  };

  const fetchGallery = () => {
    setLoading(true);
    axios
      .get(baseUrl + `app/gallery-list-by-service/${serviceId}/`, config)
      .then((response) => {
        setImageList(response.data);
      })
      .catch((error) => {
        console.error("Gallery Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteImage = (imageId) => {
    setLoading(true);
    axios
      .delete(baseUrl + `app/gallery/delete/${imageId}/`, config)
      .then(() => {
        fetchGallery();
      })
      .catch((error) => {
        console.error("Delete Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchGallery();
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, []);

  return (
    <Container fluid className="service-data-container mb-3">
      <div className="service-img">
        {loading ? (
          <div className="loader-container">
            <Spinner className="spinner-loader" />
          </div>
        ) : (
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry gutter="20px">
              {imageList.length === 0 ? (
                <div className="no-images-message">No images are available</div>
              ) : (
                imageList.map((image) => (
                  <div className="service-img-div" key={image.id}>
                    <Popup
                      className="popup-container"
                      contentStyle={{
                        borderRadius: "20px",
                        backgroundColor: "white",
                      }}
                      trigger={
                        <span className="material-icons delete-icon">
                          delete_forever
                        </span>
                      }
                      modal
                      nested
                    >
                      {(close) => (
                        <div className="delete-img-div">
                          <h3 className="delete-img-heading">Are you sure?</h3>
                          <p className="delete-img-p">
                            Do you really want to delete?
                          </p>
                          <div className="delete-btn-div">
                            <button
                              onClick={() => {
                                deleteImage(image.id);
                                close();
                              }}
                            >
                              Delete
                            </button>
                            <button onClick={close}>Cancel</button>
                          </div>
                        </div>
                      )}
                    </Popup>
                    <img
                      src={`${baseUrl}${image.service_images}`}
                      style={{
                        width: "100%",
                        display: "block",
                        cursor: "pointer",
                      }}
                      alt="Service"
                    />
                  </div>
                ))
              )}
            </Masonry>
          </ResponsiveMasonry>
        )}
        <button className="btn-add-service-image " onClick={handleOpen}>
          + Add Service Image
        </button>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: { borderRadius: "20px" },
          }}
        >
          <DialogTitle className="add-img-heading">
            Add Service Images
          </DialogTitle>
          <DialogContent>
          <div className="add-img-div">
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                handleUpload();
                handleClose();
              }}
            >
              <label className="add-file-upload mb-1">
                <input
                  className="add-img-file"
                  id="file"
                  type="file"
                  onChange={handleFileChange}
                />
                <MdOutlineFileUpload className="upload-icon" />
              </label>

              {previewUrl && (
                <div className="image-preview-container">
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="preview-image"
                  />
                </div>
              )}

              <DialogActions>
                <Button type="submit" variant="contained" color="primary">
                  Upload
                </Button>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  color="secondary"
                >
                  Cancel
                </Button>
              </DialogActions>
            </form>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </Container>
  );
};
export default ServiceImage;
